<!-- ══════════ Tabla de distancia de los tramos USDT (modal) ══════════ -->
<div class="fe td" [attr.aria-busy]="guardando">

  <!-- ───── Cabecera fija ───── -->
  <header class="fe__cabecera">
    <div class="fe__cabecera-fila">
      <h2 id="td-titulo" class="fe__titulo">
        <mat-icon class="fe__titulo-icono" aria-hidden="true">table_rows</mat-icon>
        Tabla de distancia &middot; {{ titulo }}
      </h2>
      <span class="fe__solo-lectura" *ngIf="soloLectura" role="status"><mat-icon class="fe__candado" aria-hidden="true">lock</mat-icon>Solo lectura</span>
      <button type="button" class="fe__icono-btn fe__cerrar" (click)="cerrar()" [disabled]="guardando" aria-label="Cerrar">
        <mat-icon aria-hidden="true">close</mat-icon>
      </button>
    </div>
    <p class="td__bajada" *ngIf="esVes">
      <b>Una sola tabla para USDT &rarr; VES y VES &rarr; USDT.</b> Cada ruta cae en la fila de su propio margen (su comisi&oacute;n), as&iacute; que un cambio ac&aacute; mueve las dos.
    </p>
    <p class="td__bajada" *ngIf="!esVes">
      El margen de la ruta contra el spot USD/CLP elige la fila; su ajuste es lo que se le devuelve al cliente grande.
    </p>
  </header>

  <!-- ───── Cuerpo con scroll interno ───── -->
  <div class="fe__cuerpo">
    <div *ngIf="cargando" class="fe__cargando">
      <mat-spinner diameter="28"></mat-spinner>
      <span>Cargando la tabla&hellip;</span>
    </div>

    <div *ngIf="!cargando && errorCarga" class="fe__aviso fe__aviso--rojo" role="alert">
      <span>{{ errorCarga }}</span>
      <button type="button" class="fe__btn fe__btn--secundario" (click)="cargar()">Reintentar</button>
    </div>

    <ng-container *ngIf="!cargando && tabla">
      <!-- Dónde cae cada ruta hoy -->
      <div class="td__rutas">
        <section class="td__ruta" *ngFor="let r of rutas" [attr.aria-label]="etiquetaRuta(r)">
          <p class="td__ruta-titulo">{{ etiquetaRuta(r) }}</p>
          <ng-container *ngIf="activaDe(r) as a; else rutaSinDatos">
            <dl class="td__datos">
              <dt>{{ rotulos(r).margen }}</dt>
              <dd>{{ pct(a.margenPct, 4) }}</dd>
              <dt>fila</dt>
              <dd>{{ filaActiva(r) >= 0 ? (filaActiva(r) + 1) : '—' }}<ng-container *ngIf="filaActiva(r) < 0"> &middot; todos pagan la chica</ng-container></dd>
              <dt>{{ rotulos(r).peor }} &rarr; {{ rotulos(r).mejor }}</dt>
              <dd>{{ n(a.chica) }} &rarr; {{ n(filaActiva(r) >= 0 ? resultante(r, filaActiva(r)) : a.chica) }}</dd>
              <dt>colch&oacute;n</dt>
              <dd>{{ pct(colchon(r)) }}</dd>
            </dl>
          </ng-container>
          <ng-template #rutaSinDatos><p class="fe__vacio">Sin datos de la ruta.</p></ng-template>
        </section>
      </div>

      <div class="fe__grid">
        <!-- ───── Tabla ───── -->
        <section class="fe__zona-tabla" aria-label="Filas de la tabla de distancia">
          <table class="fe__tabla td__tabla">
            <thead>
              <tr>
                <th scope="col">Min diff %</th>
                <th scope="col">Max diff %</th>
                <th scope="col" class="is-num">Ajuste %</th>
                <th scope="col" class="is-num" *ngFor="let r of rutas">{{ rotulos(r).mejor }} {{ etiquetaRuta(r) }}</th>
                <th scope="col"><span class="td__oculto">Rutas en la fila</span></th>
                <th scope="col" *ngIf="!soloLectura"><span class="td__oculto">Quitar</span></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let f of filas; let i = index; trackBy: trackIndice" [class.is-simulada]="rutasEnFila(i).length > 0">
                <!-- MIN: lo arrastra el MAX de la anterior -->
                <td>
                  <span class="fe__fijo" [attr.aria-label]="'Mínimo de la fila ' + (i + 1)">
                    <mat-icon class="fe__candado" aria-hidden="true" *ngIf="!soloLectura">lock</mat-icon>
                    {{ lim(f.minPct) }}
                  </span>
                </td>
                <!-- MAX -->
                <td>
                  <ng-container *ngIf="i < filas.length - 1; else infinito">
                    <input *ngIf="!soloLectura; else maxTexto" type="number" min="0" step="0.01" class="fe__input fe__input--corto"
                      [class.is-error]="errorMax(i)" [ngModel]="f.maxPct" (ngModelChange)="cambiarMax(i, $event)"
                      [disabled]="!editable" [attr.aria-label]="'Máximo de la fila ' + (i + 1)" [attr.aria-invalid]="errorMax(i)" />
                    <ng-template #maxTexto><span class="fe__texto-num">{{ lim(f.maxPct) }}</span></ng-template>
                  </ng-container>
                  <ng-template #infinito><span class="fe__texto-num" aria-label="sin máximo">&infin;</span></ng-template>
                </td>
                <!-- AJUSTE -->
                <td class="is-num">
                  <input *ngIf="!soloLectura; else ajusteTexto" type="number" min="0" [max]="ajusteMax" step="0.01"
                    class="fe__input fe__input--corto td__input-num" [class.is-error]="errorAjuste(i)"
                    [ngModel]="f.ajustePct" (ngModelChange)="cambiarAjuste(i, $event)" [disabled]="!editable"
                    [attr.aria-label]="'Ajuste % de la fila ' + (i + 1)" [attr.aria-invalid]="errorAjuste(i)" />
                  <ng-template #ajusteTexto><span class="fe__texto-num">{{ pct(f.ajustePct) }}</span></ng-template>
                </td>
                <!-- Tasa resultante por ruta -->
                <td class="is-num" *ngFor="let r of rutas">
                  <span class="fe__tasa">
                    {{ n(resultante(r, i)) }}
                    <mat-icon *ngIf="!esOficial(r, i) && resultante(r, i) != null" class="fe__estimada" aria-label="Estimada en tu navegador">schedule</mat-icon>
                  </span>
                </td>
                <!-- Activa -->
                <td class="td__marca">
                  <span *ngFor="let r of rutasEnFila(i)" class="fe__badge fe__badge--verde">&larr; {{ etiquetaRuta(r) }}</span>
                </td>
                <!-- Quitar -->
                <td *ngIf="!soloLectura">
                  <button type="button" class="fe__icono-btn fe__quitar" (click)="quitar(i)"
                    [disabled]="!editable || filas.length <= 1" [attr.aria-label]="'Quitar la fila ' + (i + 1)">
                    <mat-icon aria-hidden="true">remove_circle_outline</mat-icon>
                  </button>
                </td>
              </tr>

              <tr class="fe__fila-agregar" *ngIf="!soloLectura">
                <td [attr.colspan]="6 + rutas.length">
                  <button type="button" class="fe__btn fe__btn--fantasma" (click)="agregar()" [disabled]="!editable || !puedeAgregar">
                    <mat-icon aria-hidden="true">add</mat-icon>
                    Agregar fila
                  </button>
                  <button type="button" class="fe__btn fe__btn--secundario" *ngIf="hayCambios" (click)="descartar()" [disabled]="guardando">
                    Descartar cambios
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <p class="fe__nota" *ngIf="!soloLectura && !puedeAgregar">Llegaste al m&aacute;ximo de {{ filasMax }} filas.</p>
          <p class="fe__nota">
            La fila se elige con min &le; margen &lt; max; la &uacute;ltima llega a &infin;. Margen negativo o sin fila: todos pagan la chica.
            El ajuste va de 0 a {{ ajusteMax }} % y es cu&aacute;nto se acerca el tramo grande a la referencia; los tramos por monto lo reparten parejo.
          </p>
          <p class="fe__nota">
            <mat-icon class="fe__estimada" aria-hidden="true">schedule</mat-icon>
            = estimada en tu navegador. Sin &iacute;cono = tasa oficial del servidor.
          </p>
        </section>

        <!-- ───── Panel ───── -->
        <aside class="fe__panel" aria-label="Vista previa y guardado">
          <section class="fe__tarjeta" aria-live="polite">
            <div class="fe__estado-fila">
              <h3 class="fe__tarjeta-titulo">Vista previa</h3>
              <button type="button" class="fe__chip-btn" (click)="previsualizar()"
                [disabled]="previsualizando || guardando || !!erroresLocales.length">Actualizar</button>
            </div>
            <p class="fe__estado fe__estado--azul" *ngIf="previsualizando"><mat-spinner diameter="14"></mat-spinner> Calculando&hellip;</p>
            <p class="fe__estado" *ngIf="!previsualizando && vista && vistaVieja">Esperando a que termines de escribir&hellip;</p>
            <p class="fe__estado fe__estado--verde" *ngIf="vistaAlDia && !errores.length">
              <mat-icon aria-hidden="true">check_circle</mat-icon> Tasas oficiales al d&iacute;a
            </p>
            <ul class="fe__lista fe__lista--rojo" *ngIf="errores.length" role="alert">
              <li *ngFor="let e of errores">{{ e }}</li>
            </ul>
            <ul class="fe__lista fe__lista--ambar" *ngIf="(vistaAlDia ? avisos : avisosLocales).length">
              <li *ngFor="let a of (vistaAlDia ? avisos : avisosLocales)">{{ a }}</li>
            </ul>
          </section>

          <section class="fe__tarjeta" *ngIf="!soloLectura">
            <label for="td-motivo" class="fe__tarjeta-titulo">Motivo <span class="fe__obligatorio">(obligatorio)</span></label>
            <textarea id="td-motivo" rows="2" class="fe__input fe__input--area" [(ngModel)]="motivo"
              [maxlength]="motivoMax" [disabled]="!editable" [class.is-error]="!!motivo && !motivoValido"
              placeholder="Por ejemplo: subo el ajuste de la fila 0,9 – ∞"></textarea>
            <p class="fe__error-campo" *ngIf="motivo && !motivoValido">Escribe entre 5 y 255 caracteres.</p>
          </section>

          <div class="fe__aviso fe__aviso--verde" *ngIf="mensaje" role="status">{{ mensaje }}</div>
        </aside>
      </div>
    </ng-container>
  </div>

  <!-- ───── Pie fijo ───── -->
  <footer class="fe__pie">
    <div class="fe__historial" *ngIf="historialAbierto" id="td-historial">
      <p class="fe__vacio" *ngIf="!historialItems.length && !cargandoHistorial && !errorHistorial">Sin cambios registrados.</p>
      <div class="fe__tabla-caja" *ngIf="historialItems.length">
        <table class="fe__tabla fe__tabla--historial" [class.is-cargando]="cargandoHistorial">
          <thead>
            <tr>
              <th scope="col">Fecha</th>
              <th scope="col">Acci&oacute;n</th>
              <th scope="col">Antes</th>
              <th scope="col">Despu&eacute;s</th>
              <th scope="col">Qui&eacute;n</th>
              <th scope="col">Motivo</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let h of historialItems">
              <td class="is-nowrap">{{ h.createdAt | date:'dd/MM/yyyy HH:mm' }}</td>
              <td><b>{{ h.accion }}</b></td>
              <td class="td__hist">{{ antesDespues(h).antes }}</td>
              <td class="td__hist">{{ antesDespues(h).despues }}</td>
              <td>{{ h.editadoPor || '—' }}</td>
              <td>{{ h.motivo || '—' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="fe__error-campo" *ngIf="errorHistorial" role="alert">{{ errorHistorial }}</p>
      <div class="fe__paginacion" *ngIf="hayPaginacion">
        <button type="button" class="fe__btn fe__btn--secundario" (click)="irAPagina(historialPagina - 1)"
          [disabled]="historialPagina <= 1 || cargandoHistorial">&lsaquo; Anteriores</button>
        <span aria-live="polite">{{ cargandoHistorial ? 'Cargando…' : 'Página ' + historialPagina + ' de ' + paginasHistorial }}</span>
        <button type="button" class="fe__btn fe__btn--secundario" (click)="irAPagina(historialPagina + 1)"
          [disabled]="historialPagina >= paginasHistorial || cargandoHistorial">Siguientes &rsaquo;</button>
      </div>
    </div>

    <div class="fe__pie-fila">
      <button type="button" class="fe__btn fe__btn--texto" (click)="toggleHistorial()"
        [attr.aria-expanded]="historialAbierto" aria-controls="td-historial" [disabled]="!tabla">
        Historial<ng-container *ngIf="historialLeido"> ({{ historialTotal }})</ng-container>
        <mat-icon aria-hidden="true">{{ historialAbierto ? 'expand_more' : 'chevron_right' }}</mat-icon>
      </button>
      <div class="fe__pie-acciones">
        <span class="fe__pie-motivo fe__pie-motivo--candado" *ngIf="soloLectura">
          <mat-icon aria-hidden="true">lock</mat-icon>{{ textoSoloLectura }}
        </span>
        <span class="fe__pie-motivo" *ngIf="!soloLectura && !puedeGuardar && !guardando && tabla">{{ motivoNoGuardar }}</span>
        <button type="button" class="fe__btn fe__btn--secundario" (click)="cerrar()" [disabled]="guardando">
          {{ soloLectura ? 'Cerrar' : 'Cancelar' }}
        </button>
        <button type="button" class="fe__btn fe__btn--primario" (click)="guardar()" [disabled]="!puedeGuardar" *ngIf="!soloLectura">
          <mat-spinner *ngIf="guardando" diameter="16" class="fe__spinner-blanco"></mat-spinner>
          {{ guardando ? 'Guardando…' : 'Guardar tabla' }}
        </button>
      </div>
    </div>
  </footer>

  <div class="fe__bloqueo" *ngIf="guardando" role="status" aria-live="assertive">
    <mat-spinner diameter="40"></mat-spinner>
    <span>Guardando&hellip;</span>
  </div>
</div>
